/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { loadDocumentScoringHistory } from "../actionCreators";
import { RightsContext } from "providers/RightsContext";
import { getScoringHistory } from "../selectors";
import DocumentScoringSessionHistoryListComponent from "./DocumentScoringSessionHistoryListComponent";

export const DocumentScoringHistoryContainer = ({
  actions,
  documentId,
  siteId,
  scoringHistory,
  onOpenScoringSessionHistory
}) => {
  const {
    scoringScoringSummaryRead,
    scoringKoRead,
    scoringGridDocumentRead,
    scoringGridClientRead,
    scoringGridAssetRead
  } = useContext(RightsContext);

  useEffect(() => {
    if (hasNoRights()) {
      return;
    }

    actions.loadDocumentScoringHistory(documentId, siteId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(
    () => {
      if (hasNoRights()) {
        return;
      }
      actions.loadDocumentScoringHistory(documentId, siteId);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [scoringScoringSummaryRead, scoringKoRead, scoringGridDocumentRead, scoringGridClientRead, scoringGridAssetRead]
  );

  const hasNoRights = () => {
    return (
      !scoringScoringSummaryRead &&
      !scoringKoRead &&
      !scoringGridDocumentRead &&
      !scoringGridClientRead &&
      !scoringGridAssetRead
    );
  };

  return (
    <>
      {scoringHistory.loaded && scoringHistory.scoringSessionsHistory.length > 0 && (
        <DocumentScoringSessionHistoryListComponent
          scoringSessionHistory={scoringHistory.scoringSessionsHistory}
          onOpenScoringSessionHistory={onOpenScoringSessionHistory}
        />
      )}
    </>
  );
};

DocumentScoringHistoryContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  siteId: PropTypes.number,
  documentId: PropTypes.number,
  scoringHistory: PropTypes.object.isRequired,
  onOpenScoringSessionHistory: PropTypes.func.isRequired
};

function mapStateToProps(state, route) {
  const key = `${route.documentId}-${route.siteId}`;
  return {
    scoringHistory: getScoringHistory(state, key)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadDocumentScoringHistory }, dispatch),
    dispatch
  };
}

export default withRouter(compose(connect(mapStateToProps, mapDispatchToProps))(DocumentScoringHistoryContainer));
